import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  container: {
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
  },
  header: {
    gap: spacing(20), // same as problemRow gap
    width: '100%',
    display: 'flex',
    paddingLeft: '38px',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  headerLabel: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  materialWrapper: {
    marginLeft: spacing(20),
    marginTop: spacing(20),
    width: '800px',
  },
  problemRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    minHeight: spacing(60),
    paddingLeft: spacing(12),
    paddingTop: spacing(4),
    gap: spacing(16), // same as header gap
  },
  materialRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    minHeight: spacing(40),
    paddingLeft: spacing(38),
    paddingTop: spacing(4),
    gap: spacing(16), // same as header gap
  },
  totalValueContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: spacing(16),
    marginTop: spacing(8),
  },
  totalValueText: {
    fontSize: '16px',
    color: '#141414',
  },
  dragIcon: {
    transform: 'translateY(22px)',
    alignSelf: 'flex-start',
  },
  tooltip: {
    maxWidth: 'none',
  },
  tooltipContent: {
    padding: '4px',
  },
  tooltipHeader: {
    fontWeight: 'bold',
    marginBottom: '4px',
  },
  tooltipRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    fontSize: '12px',
  },
  aiIcon: {
    color: Theme.Colors.Primary.Base,
    width: '20px',
    height: '20px',
  },
  aiIconDisabled: {
    color: Theme.Colors.Grayscale.ThirtyTwo,
  },
  tradesmanDetailList: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: spacing(16),
    width: '100%',
  },
  tradesmanDetailDescription: {
    color: palette?.gray?.[80] ?? '#696969',
    paddingBottom: spacing(8),
    fontSize: spacing(14),
  },
  tradesmanDetailPrice: {
    color: palette?.gray?.[80] ?? '#696969',
    paddingBottom: spacing(8),
    fontSize: spacing(14),
  },
  tradesmanDetailItem: {
    padding: spacing(10),
    border: `1px solid ${palette?.gray?.[12] ?? '#E3E3E3'}`,
    borderRadius: spacing(4),
    fontSize: spacing(14),
    marginBottom: spacing(5),
    minHeight: spacing(40),
    display: 'flex',
    alignItems: 'center',
  },
}))
